import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommand} from '@shared/commands/command-base';
import {take, takeUntil} from 'rxjs/operators';
import {TaskManagerService} from '../../task-manager/services/task-manager.service';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {Subject} from 'rxjs';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {
  DeleteSurveyCommand,
  DeleteSurveyExecutionCommand,
  SurveyTemplateExportCommand,
  SurveyTemplateReportCommand
} from '../commands/survey.commands';
import {DialogModel} from '@shared/models/dialog.model';
import {FileManagementService} from '@core/services/file-management.service';
import {DeleteSurveyAction} from '../store/actions/data-survey.actions';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Configuration} from '@shared/models/configuration';

@Injectable({
  providedIn: 'root',
})
export class PlatformToolDataSurveyHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  private selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  activatedRoute: ActivatedRoute;

  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private taskManagerService: TaskManagerService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              protected store: Store<IQueryState>
  ) {
  }

  invalidateSubject: InvalidateSubject;

  executeCommand(command: PlatformCommand, callBack?: any) {
    console.log(command);
    switch (command.name) {
      case 'CreateSurveyTemplateCommand':
        this.addTemplate(command);
        break;
      case 'SurveyTemplateImportCommand':
        this.dialogService.showImportSurveyDialog('', '', true, {});
        break;
      default:
        this.executeCommandToApi(command);
        break;
    }

  }

  addTemplate(command: PlatformCommand) {
    const dialogModel: DialogModel = DialogModel.create(
      'Add Template',
      'AddTemplateDialogComponent', {},
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res.action === 'OK') {
        command.fieldValues['Title'] = res.data.input.name;
        command.fieldValues['Description'] = res.data.input.description;
        console.log('Command', command);
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
            console.log('commandState', response);
            const surveyId = response.fieldValues['SurveyId'];
            this.router.navigateByUrl(`data-survey/templates/${surveyId}/edit`);
          },
          error => {
            this.fuseSplashScreenService.hide();
            console.error('Failed CreateSurveyTemplateCommand', error);
          });

      }
    });
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      if (command.name && command.name === 'ToggleInformationFilterCommand') {
        command.fieldValues['CurrentTab'] = this.selectedTabModel.name;
      }
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if ($event.item && $event.fieldDefinition && $event.fieldSection) {
      if ($event.fieldSection.id === 'datasurveyexecution') {
        this.executeSurveyExecutionActions($event);
        return;
      } else if ($event.fieldSection.id === 'datasurveygeneral') {
        this.executeSurveyTemplateActions($event);
      } else if ($event.fieldSection.id === 'datasurveyparticipant') {
        this.executeSurveyParticipantActions($event);
      } else if ($event.fieldSection.id === 'scheduleddatasurvey') {
        this.executeScheduledSurveyActions($event);
      }
    }
  }

  fetchMagicLink(callback: any) {
    const id = this.magicLinkModel.id;
    this.httpClient.get<MagicLinkModel>(`${Configuration.getConfig('DataSurveyApi')}Platform/LinkById?id=${id}`).pipe(take(1)).subscribe(
      data => {
        this.magicLinkModel = data;
        callback(data);
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Information bar error', error);
      }
    );
  }

  magicLinkModelValueChangedHandler(payload: any) {
    this.magicLinkModelValueChanged.emit(payload);
  }

  onGridRowChanges() {
    this.fetchMagicLink(() => {
      const payload = {id: 'PlatformToolInformationBarComponent', value: this.magicLinkModel['informationBar']};
      this.magicLinkModelValueChanged.emit(payload);
    });
  }

  private executeSurveyTemplateActions($event) {
    if ($event.action) {
      switch ($event.action.id) {
        case 'Edit':
          this.router.navigate(['../..', $event.item.id, 'edit'], {relativeTo: this.activatedRoute});
          return;
        case 'SendDataSurvey':
          this.router.navigateByUrl(`data-survey/${$event.item.id}/edit`);
          return;
        case 'DesignSurvey':
          this.router.navigateByUrl(`data-survey/templates/${$event.item.id}/edit`);
          return;
        case 'Delete':
          this.deleteSurveyTemplate($event);
          return;
        case 'DownloadJson':
          this.downloadJson($event);
          return;
        case 'DownloadPdf':
          this.downloadPdf($event);
          return;
        case 'DownloadDocx':
          this.downloadDocx($event);
          return;
        case 'CopySurvey':
          this.addSurvey($event.item.id);
          return;
      }
    }
    switch ($event.fieldDefinition.key) {
      case 'title':
        this.router.navigateByUrl(`data-survey/templates/${$event.item.id}/edit`);
        return;
    }
  }

  private deleteSurveyTemplate($event) {
    this.dialogService.showYesNoDialog('Delete Survey', 'Are you sure you want to delete this survey?').pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
      if (result && result.action === 'OK') {
        const deleteSurveyCommand = new DeleteSurveyCommand([$event.item.id]);
        if (this.selectedTabModel) {
          deleteSurveyCommand.selectedTabId = this.selectedTabModel.id;
        }
        this.store.dispatch(new DeleteSurveyAction(deleteSurveyCommand, this.invalidateSubject));
      }
    });
  }

  addSurvey(copyFromSurveyId: string = null) {
    this.dialogService.showAndStartSurvey('', '', true, {}, copyFromSurveyId);
  }

  private downloadDocx($event) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new SurveyTemplateReportCommand($event.item.id, 'docx')).pipe().subscribe(response => {
      if (response && response.Payload && response.Payload.Id) {
        this.fileManagementService.downloadClientFileWithId(response.Payload.Id).subscribe(payload => {
          this.fileManagementService.openSaveFileWindow(payload, `Survey Template-${$event.item.cells.title.displayText}.docx`);
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  private downloadPdf($event) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new SurveyTemplateReportCommand($event.item.id, 'pdf')).pipe().subscribe(response => {
      if (response && response.Payload && response.Payload.Id) {
        this.fileManagementService.downloadClientFileWithId(response.Payload.Id).subscribe(payload => {
          this.fileManagementService.openSaveFileWindow(payload, `Survey Template-${$event.item.cells.title.displayText}.pdf`);
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  private downloadJson($event) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new SurveyTemplateExportCommand($event.item.id)).pipe().subscribe(response => {
      if (response && response.Payload && response.Payload.Id) {
        this.fileManagementService.downloadClientFileWithId(response.Payload.Id).subscribe(payload => {
          this.fileManagementService.openSaveFileWindow(payload, `Survey Template-${$event.item.cells.title.displayText}.json`);
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  private executeSurveyExecutionActions($event) {
    switch ($event.fieldDefinition.key) {
      case 'title':
        this.openSurveyExecution($event);
        return;
      case 'template':
        // this.openSurveyTemplate($event);
        this.router.navigateByUrl(`data-survey/templates/${$event.item.cells.template.value.id}/edit`);
        return;
    }
  }

  private executeSurveyParticipantActions($event) {
    if ($event.action) {
      switch ($event.action.id) {
        case 'OpenSurveyExecution':
          this.router.navigateByUrl(`data-survey/response/${$event.item.cells['ExecutionId'].value}/${$event.item.cells['UserId'].value}`);
          return;
      }
    }
    switch ($event.fieldDefinition.key) {
      case 'Title':
        this.router.navigateByUrl(`data-survey/response/${$event.item.cells['ExecutionId'].value}/${$event.item.cells['UserId'].value}`);
        return;
    }

  }

  private executeScheduledSurveyActions($event) {

    if ($event.action) {
      switch ($event.action.id) {
        case 'Edit':
          this.openSurveyExecutionEditor($event);
          break;
      }
    }

    switch ($event.fieldDefinition.key) {
      case 'title':
        this.openSurveyExecution($event);
        break;
      case 'template':
        this.router.navigateByUrl(`data-survey/templates/${$event.item.cells.template.value.id}/edit`);
        break;
    }
  }

  private openSurveyTemplate($event: any) {
    const command = new PlatformCommand('CreateSurveyTemplateLinkCommand', 'DataSurveyApi');
    command.fieldValues['SurveyId'] = $event.item.id;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed openSurveyExecution ', error);
      });
  }

  private openSurveyExecution($event: any) {
    const command = new PlatformCommand('CreateSurveyExecutionLinkCommand', 'DataSurveyApi');
    command.fieldValues['ExecutionId'] = $event.item.id;
    command.fieldValues['ViewType'] = 'GridView';
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed openSurveyExecution ', error);
      });
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      this.executeCommand($event.command);
      return true;
    }
    return false;
  }

  private handleAction($event): boolean {
    if (this.selectedTabModel && $event.action) {
      switch ($event.action.id) {
        case 'OpenSurveyExecution':
          if ($event.fieldSection && $event.fieldSection.id === 'datasurveyparticipant') {
            return false;
          } else {
            this.openSurveyExecution($event);
          }
          return true;
        case 'Delete':
          if ($event.item.type === 'SurveyExecution') {
            this.deleteSurveyExecution($event);
          }

          return;
      }
    }
    return false;
  }

  private deleteSurveyExecution($event) {
    this.dialogService.showYesNoDialog('Delete Survey Execution', 'Are you sure you want to delete this survey execution?').pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
      if (result && result.action === 'OK') {
        let command = new DeleteSurveyExecutionCommand([$event.item.id]);
        command.tabName = this.selectedTabModel.name;
        this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.snackBarService.showInformation('Survey is deleted');
          const platformCommand = new PlatformCommand('SyncUserInformationCounterCommand', 'DataSurveyApi');
          platformCommand.fieldValues['PlatformLinkId'] = this.magicLinkModel.id;
          platformCommand.fieldValues['InformationCounterId'] = this.magicLinkModel.informationBar.informationCounterId;
          platformCommand.fieldValues['IsNewPlatformLink'] = false;
          this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(platformCommandResponse => {
            console.log(platformCommandResponse);
            this.onGridRowChanges();
          });
        });
      }
    });
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  addNewRecord(payload) {
    const addRowCommand = this.selectedTabModel.tabData['AddRowCommand'];
    this.executeCommandToApi(addRowCommand);
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  private openSurveyExecutionEditor(event) {
    const sourceType = this.selectedTabModel.tabData['SectionType'];
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '800px', '1500px', sourceType)
      .subscribe(state => {
        if (state.action === 'OK') {
          const command = new PlatformCommand('UpdateSurveyExecutionCommand', 'DataSurveyApi');
          command.fieldValues['SurveyExecutionId'] = event.item.id;
          command.fieldValues[event.fieldDefinition.key] = event.item.cells[event.fieldDefinition.key].value;
          this.commandService.executePlatformCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            console.log('Command State', res);
            this.invalidateSubject.invalidate();
          });
        }
      });
  }
}
